import { 
  REVISION_PRICE_INFO,
  REVISION_PRICE_STEP,
  REVISION_PRICE_LOGS,
  REVISION_PRICE_RATE,
  REVISION_PRICE_ID,
  NEXT_REVISION_INFO
} from "../actionTypes";

const setRevisionPriceInfo = (rvsInfo) => ({
  type: REVISION_PRICE_INFO,
	info: rvsInfo
})

const setRevisionPriceStep = (rvsStep) => ({
  type: REVISION_PRICE_STEP,
	step: rvsStep.step
})

const setRevisionLogs = (rvsLogs) => ({
  type: REVISION_PRICE_LOGS,
	logs: rvsLogs.logs
})

const setRevisionPriceRate = (rvsRate) => ({
  type: REVISION_PRICE_RATE,
	rate: rvsRate.rate
})

const setRevisionPriceId = (rvsId) => ({
  type: REVISION_PRICE_ID,
	id: rvsId.id
})

const setNextRevisionInfo = (rvsNextInfo) => ({
  type: NEXT_REVISION_INFO,
	nextInfo: rvsNextInfo
})

export {
	setRevisionPriceInfo,
  setRevisionPriceStep,
  setRevisionLogs,
  setRevisionPriceRate,
  setRevisionPriceId,
  setNextRevisionInfo
}


// WEBPACK FOOTER //
// ./src/store/actions/revisionPrice.js